"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALL_DEPTH_SIZE_PAIRS = exports.SPL_NOOP_PROGRAM_ID = exports.SPL_NOOP_ADDRESS = void 0;
const web3_js_1 = require("@solana/web3.js");
exports.SPL_NOOP_ADDRESS = 'noopb9bkMVfRPU8AsbpTUg8AQkHtKwMYZiFUjNRtMmV';
exports.SPL_NOOP_PROGRAM_ID = new web3_js_1.PublicKey(exports.SPL_NOOP_ADDRESS);
const allPairs = [
    [3, 8],
    [5, 8],
    [6, 16],
    [7, 16],
    [8, 16],
    [9, 16],
    [10, 32],
    [11, 32],
    [12, 32],
    [13, 32],
    [14, 64],
    [14, 256],
    [14, 1024],
    [14, 2048],
    [15, 64],
    [16, 64],
    [17, 64],
    [18, 64],
    [19, 64],
    [20, 64],
    [20, 256],
    [20, 1024],
    [20, 2048],
    [24, 64],
    [24, 256],
    [24, 512],
    [24, 1024],
    [24, 2048],
    [26, 512],
    [26, 1024],
    [26, 2048],
    [30, 512],
    [30, 1024],
    [30, 2048],
];
/**
 * Valid pairs for creating a new {@link ConcurrentMerkleTreeAccount}
 */
exports.ALL_DEPTH_SIZE_PAIRS = allPairs.map(pair => {
    return {
        maxBufferSize: pair[1],
        maxDepth: pair[0],
    };
});
//# sourceMappingURL=index.js.map